import { render, staticRenderFns } from "./PageOrderFeedback.vue?vue&type=template&id=978bb2ea&"
import script from "./PageOrderFeedback.vue?vue&type=script&lang=js&"
export * from "./PageOrderFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('978bb2ea')) {
      api.createRecord('978bb2ea', component.options)
    } else {
      api.reload('978bb2ea', component.options)
    }
    module.hot.accept("./PageOrderFeedback.vue?vue&type=template&id=978bb2ea&", function () {
      api.rerender('978bb2ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/PageOrderFeedback.vue"
export default component.exports